import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Public API (no auth)
const publicAPI = axios.create({ baseURL: `${API_URL}/api/public/academy` });

// Admin API (with auth)
const adminAPI = axios.create({ baseURL: `${API_URL}/api/academy` });
adminAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const academyPublicAPI = {
  getSettings: () => publicAPI.get('/settings'),
  getCategories: () => publicAPI.get('/categories'),
  getTrainings: (params) => publicAPI.get('/trainings', { params }),
  getTraining: (slug) => publicAPI.get(`/trainings/${slug}`),
  getInstructors: () => publicAPI.get('/instructors'),
  getSessions: (courseId) => publicAPI.get(`/sessions/${courseId}`),
  register: (data) => publicAPI.post('/register', data, {
    headers: { 'X-Origin-URL': window.location.origin }
  }),
  checkoutStatus: (sessionId) => publicAPI.get(`/checkout-status/${sessionId}`),
};

export const academyAdminAPI = {
  // Categories
  listCategories: () => adminAPI.get('/categories'),
  createCategory: (data) => adminAPI.post('/categories', data),
  updateCategory: (id, data) => adminAPI.put(`/categories/${id}`, data),
  deleteCategory: (id) => adminAPI.delete(`/categories/${id}`),
  // Instructors
  listInstructors: () => adminAPI.get('/instructors'),
  createInstructor: (data) => adminAPI.post('/instructors', data),
  updateInstructor: (id, data) => adminAPI.put(`/instructors/${id}`, data),
  deleteInstructor: (id) => adminAPI.delete(`/instructors/${id}`),
  // Trainings
  listTrainings: () => adminAPI.get('/trainings'),
  getTraining: (id) => adminAPI.get(`/trainings/${id}`),
  createTraining: (data) => adminAPI.post('/trainings', data),
  updateTraining: (id, data) => adminAPI.put(`/trainings/${id}`, data),
  deleteTraining: (id) => adminAPI.delete(`/trainings/${id}`),
  // Sessions
  listSessions: (params) => adminAPI.get('/sessions', { params }),
  createSession: (data) => adminAPI.post('/sessions', data),
  updateSession: (id, data) => adminAPI.put(`/sessions/${id}`, data),
  deleteSession: (id) => adminAPI.delete(`/sessions/${id}`),
  // Registrations
  listRegistrations: (params) => adminAPI.get('/registrations', { params }),
  updateRegistration: (id, data) => adminAPI.put(`/registrations/${id}`, data),
  deleteRegistration: (id) => adminAPI.delete(`/registrations/${id}`),
  // Certificates
  listCertificates: () => adminAPI.get('/certificates'),
  generateCertificate: (regId) => adminAPI.post(`/certificates/generate/${regId}`),
  deleteCertificate: (id) => adminAPI.delete(`/certificates/${id}`),
  // Analytics
  getAnalytics: () => adminAPI.get('/analytics'),
  // Payments
  listPayments: () => adminAPI.get('/payments'),
  // Settings
  getSettings: () => adminAPI.get('/settings'),
  updateSettings: (data) => adminAPI.put('/settings', data),
};
